import { handleErrors } from "../util/api-utils";

export function GetClientConfiguration(successCallback) {
    fetch("api/ClientConfiguration/GetClientConfiguration")
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
}
